import type {ConferencingToolConfigs} from 'src/types/scheduler/conferencing-tools';
import type {SchedulerConferencingToolsActions} from 'src/action-creators/scheduler/conferencing-tools';

import {SET_CONFERENCING_TOOL_CONFIGS} from 'src/action-creators/scheduler/conferencing-tools';


export default (
  state: ConferencingToolConfigs = [],
  action: SchedulerConferencingToolsActions,
): ConferencingToolConfigs => {
  switch (action.type) {
    case SET_CONFERENCING_TOOL_CONFIGS:
      return action.payload;
    default:
      return state;
  }
};
